import { render, staticRenderFns } from "./ManageUserDetail.vue?vue&type=template&id=16649b37&"
import script from "./ManageUserDetail.vue?vue&type=script&lang=js&"
export * from "./ManageUserDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports